import { EyesPosition } from 'src/models/Session.model';

import BadQualityInfoCard from './BadQualityInfoCard';
import GradableInfoCard from './GradableInfoCard';
import MaxAttemptInfoCard from './MaxAttemptInfoCard';
import SomethingWrongInfoCard from './SomethingWrongInfoCard';
import TakingTooLongInfoCard from './TakingTooLongInfoCard';

type InfoCardControllerProps = {
  hasServerError: boolean;
  isMaxAttempt: boolean;
  gradableEyesPosition: EyesPosition | undefined;
  isAnalyzing: boolean;
  isTakingTooLong: boolean;
};

export default function InfoCardController({
  hasServerError,
  isMaxAttempt,
  gradableEyesPosition,
  isAnalyzing,
  isTakingTooLong,
}: InfoCardControllerProps) {
  if (hasServerError) {
    return <SomethingWrongInfoCard />;
  }
  if (isTakingTooLong) {
    return <TakingTooLongInfoCard />;
  }
  if (isAnalyzing) {
    return null;
  }
  // Post analysis cards
  if (isMaxAttempt) {
    return <MaxAttemptInfoCard />;
  }
  if (gradableEyesPosition === undefined) {
    return <BadQualityInfoCard eye={EyesPosition.BOTH} />;
  }
  if (gradableEyesPosition === EyesPosition.LEFT) {
    return <BadQualityInfoCard eye={EyesPosition.RIGHT} />;
  }
  if (gradableEyesPosition === EyesPosition.RIGHT) {
    return <BadQualityInfoCard eye={EyesPosition.LEFT} />;
  }
  if (gradableEyesPosition === EyesPosition.BOTH) {
    return <GradableInfoCard />;
  }
}
